const Sizes = Object.freeze({
    Small: 1,
    Large: 2
});

export default Sizes; // TODO this is wrong? idk how to export multiple things?